import CallReportTable from 'components/tables/call-report/CallReportTable'
import React from 'react'

const index = () => {
    return (
        <CallReportTable />
    )
}

export default index